import React from "react";

function roleLabel(role) {
  return role ? role.charAt(0).toUpperCase() + role.slice(1) : "Staff";
}

export default function StaffTable({ staff, loading, canEdit, onView, onEdit, onToggleStatus }) {
  if (loading) return <div className="bg-white border rounded-lg p-8 text-center">Loading staff...</div>;

  return (
    <div className="bg-white border rounded-lg shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3">Name</th>
              <th className="text-left px-4 py-3">Email</th>
              <th className="text-left px-4 py-3">Role</th>
              <th className="text-left px-4 py-3">Mobile</th>
              <th className="text-left px-4 py-3">Joining Date</th>
              <th className="text-left px-4 py-3">Leaving Date</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-right px-4 py-3">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {staff.map((member) => (
              <tr key={member.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium">{member.name || member.username || "—"}</td>
                <td className="px-4 py-3">{member.email || "—"}</td>
                <td className="px-4 py-3">{roleLabel(member.role)}</td>
                <td className="px-4 py-3">{member.mobile || "—"}</td>
                <td className="px-4 py-3">{member.joiningDate || "—"}</td>
                <td className="px-4 py-3">{member.leavingDate || "—"}</td>
                <td className="px-4 py-3">
                  <span className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold ${member.status === "inactive" ? "bg-gray-200 text-gray-700" : "bg-green-100 text-green-700"}`}>
                    {member.status === "inactive" ? "Inactive" : "Active"}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex justify-end gap-2 whitespace-nowrap">
                    <button onClick={() => onView(member)} className="text-blue-600 hover:underline">View</button>
                    {canEdit && <button onClick={() => onEdit(member)} className="text-indigo-600 hover:underline">Edit</button>}
                    {canEdit && (
                      <button
                        onClick={() => onToggleStatus(member)}
                        className={member.status === "inactive" ? "text-green-700 hover:underline" : "text-red-600 hover:underline"}
                      >
                        {member.status === "inactive" ? "Reactivate" : "Deactivate"}
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            {staff.length === 0 && (
              <tr><td colSpan="8" className="px-4 py-10 text-center text-gray-500">No staff records found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
